import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root'
})
export class WildcardRedirectGuard implements CanActivate {

    constructor(
        private http: HttpService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean | UrlTree> {
        return this.http
            .get('/api/v1/wp/mitra/auth/get-user-id', {})
            .pipe(
                map((res: any) => {
                    const userId = res?.data?.user_id;

                    if (userId) {
                        return this.router.createUrlTree(['/mitra', userId]);
                    }

                    return this.router.createUrlTree(['/login']);
                }),
                catchError(() => {
                    return of(this.router.createUrlTree(['/login']));
                })
            );
    }
}
